module.exports = __webpack_public_path__ + "static/media/giz_1.907fe1f0.png";